import { getTrimValue } from './get-trim-value';

export function trimValue(value: string | null, defaultValue: string | null = null) {
  value = getTrimValue(value, defaultValue);
}
